export default __webpack_public_path__ + "static/media/restaurant.c8a2ca62.jpg";